import { useCallback, useState } from 'react'
import useAuthorizedAction, { AUTHORIZE_STAGE } from '../account/useAuthorizedAction'
import { getSessionTokens } from '../../app/api/sessionTokens'
import { useDownloadInstallerMutation, useSetupInstallerMutation } from './installersApi'
export const isHostedEndpoint = (endpoint) => Boolean(endpoint) && endpoint.type === 1
export const installerRequest = (connection, side) => {
    const endpoint = connection[side]
    return {
        subscriptionId: connection.subscriptionId,
        endpointId: endpoint.id,
        instanceId: connection.instances && connection.instances[0] ? connection.instances[0].id : null,
        fileType: endpoint.installer ? endpoint.installer.type : 1
    }
}
const useInstallerAction = (request, isHosted) => {
    const authorized = useAuthorizedAction()
    const [downloadInstaller] = useDownloadInstallerMutation()
    const [setupInstaller] = useSetupInstallerMutation()
    const [message, setMessage] = useState(null)
    const start = useCallback(() => {
        setMessage(null)
        return authorized.run(async () => {
            const tokens = await getSessionTokens()
            const body = { ...request, refreshToken: tokens ? tokens.accessToken : null }
            if (isHosted) {
                const result = await setupInstaller(body).unwrap()
                return { tone: 'info', text: (result && result.message) || 'Setup started.' }
            }
            const result = await downloadInstaller(body).unwrap()
            return { tone: 'success', text: `Downloaded ${result.fileName}` }
        })
        .then(setMessage)
        .catch((error) => setMessage({ tone: 'error', text: error.message || 'The installer could not be started.' }))
    }, [authorized, request, isHosted, setupInstaller, downloadInstaller])

    const busyLabel = {
        [AUTHORIZE_STAGE.CHECKING]: 'Checking access...',
        [AUTHORIZE_STAGE.AUTHORIZING]: 'Waiting for authorization...',
        [AUTHORIZE_STAGE.RUNNING]: isHosted ? 'Setup in progress...' : 'Downloading...'
    }[authorized.stage] || null
    return { start, isBusy: authorized.isBusy, busyLabel, message }
}

export default useInstallerAction
